export default __webpack_public_path__ + "static/media/exclamation_mark.089fd3b5.svg";